var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading-overlay',{attrs:{"active":true,"can-cancel":false,"is-full-page":true,"loader":"dots","color":"#5122b0"}})}
var staticRenderFns = []

export { render, staticRenderFns }